import { WidgetData } from "./data"
import { Element } from "./element"

export abstract class Widget extends Element {
  constructor(data: WidgetData) {
    super(data);
  }
}
